import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import { HeadCell } from '../../components/tables/BakeasyTable';
import { useLocation, useNavigate } from 'react-router-dom';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import { t } from 'i18next';
import { BakeasyButtonExport, BakeasyButtonPrint } from '../../components/buttons/BakeasyButton';
import BakeasyLabelText from '../../components/lables/BakeasyLabelText';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import {
  downloadRecipeBuilder,
  fetchRecipeByProduct,
  recipesState
} from '../../redux_store/slices/recipeBuilderSlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';

export const RecipeBuilder: FC = (): ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [ingredientList, setIngredientList] = useState<any[]>([]);
  const [productName, setProductName] = useState<string>('');
  const [orderId, setOrderId] = useState<string>('');
  const [productQuantity, setProductQuantity] = useState<any>('');
  const [productType, setProductType] = useState<any>('');
  const [recipeType, setRecipeType] = useState<any>('-');

  let { value } = useAppSelector(recipesState);

  useEffect(() => {
    fetchData(location?.state?.productId, location?.state?.payload);
  }, []);

  const fetchData = async (_id: any, payload: any) => {
    try {
      //delete payload.productionReport;
      dispatch(fetchRecipeByProduct({ productId: _id, ...payload }));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    }
  };

  useEffect(() => {
    if (value) {
      setData(value);
    }
  }, [value]);

  function setData(data: any) {
    setProductType(data?.productType);
    setRecipeType(data?.receipeBuilderType);
    setOrderId(data?.orderId);
    setProductName(data?.productName);
    setProductQuantity(data?.totalQuantity);
    const productIng = data?.ingredients?.map((item: any) => {
      return {
        // ...item,
        ingredientName: item?.ingredientName,
        // measureType: item?.unit,
        measureType: { measureType: { ...item.measureType } },
        units: item?.quantity,
        totalRequired: item?.totalRequired
      };
    });
    if (productIng?.length > 0) {
      setIngredientList([...productIng]);
    } else {
      setIngredientList([]);
    }
  }

  const tableHeaders: HeadCell[] = [
    { id: 'ingredientName', label: 'INGREDIENTS', width: '200px' },
    { id: 'measureType', label: 'MEASURE_TYPE', width: '120px', disabled: true },
    { id: 'units', label: 'MEASURE_PER_UNITS', width: '120px', disabled: true },
    { id: 'totalRequired', label: 'TOTAL_REQUIRED', width: '120px' }
  ];

  function recipeBuilderUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t('RECIPE_BUILDER_BY_SINGLE_PRODUCT')}
            menus={
              <>
                <div className="tableOptions">
                  <BakeasyButtonPrint
                    onClick={function(
                      event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                    ): void {
                      dispatch(
                        downloadRecipeBuilder({
                          productId: location?.state?.productId,
                          // requestedDeliveryDate: location?.state?.payload?.requestedDeliveryDate,
                          ...location?.state?.payload,
                          downloadType: 'pdf'
                        })
                      );
                    }}
                  />

                  <BakeasyButtonExport
                    onClick={function(
                      event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                    ): void {
                      dispatch(
                        downloadRecipeBuilder({
                          productId: location?.state?.productId,
                          //requestedDeliveryDate: location?.state?.payload?.requestedDeliveryDate,
                          ...location?.state?.payload,
                          downloadType: 'csv'
                        })
                      );
                    }}
                  />
                </div>
              </>
            }
            //description={f()}
            onBackClick={() => {
              navigate(-1);
            }}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          {/* <Grid container>
            <BakeasyHeaderLabel message={"RECIPE_BUILDER_REPORT"} />
          </Grid> */}

          {/* <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
              <Grid item>
                <BakeasyHeadingValue heading={"TYPE"} value={"Food Prep"} />
              </Grid>
              <Grid item>
                <BakeasyHeadingValue
                  heading={"ORDER_ID"}
                  value={"CAV-051524-0001"}
                />
              </Grid>
              <Grid item>
                <BakeasyHeadingValue
                  heading={"PRODUCT_NAME"}
                  value={"Tortiere"}
                />
              </Grid>
              <Grid item>
                <BakeasyHeadingValue heading={"PRODUCT_QUANTITY"} value={"8"} />
              </Grid>
            </Grid>
          </Grid> */}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('PRODUCT_TYPE')}
                // value={productType}
                value={
                  productType
                    ? t(`${productType?.toUpperCase().replace(/\s+/g, '_')}`)
                    : productType
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('RECIPE_BUILDER_TYPE')}
                value={t(recipeType)}
                // value={recipeType ? t(`${recipeType?.toUpperCase().replace(/\s+/g, '_')}`) : recipeType}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('ORDER_ID')} value={orderId} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('PRODUCT_NAME')} value={productName} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('PRODUCT_QUANTITY')} value={productQuantity} />
            </Grid>
            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('PRODUCTION_DATE')} value={'-'} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('PRODUCTION_ID')} value={'-'} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('NOTE')} value={'-'} />
            </Grid> */}
          </Grid>
          <Grid mt={2}>
            {ingredientList.length > 0 && (
              <BakeasySimpleTable headers={tableHeaders} tableData={ingredientList} />
            )}
            {/* {ingredientList.length > 0 ? (
              <BakeasySimpleTable headers={tableHeaders} tableData={ingredientList} />
            ) : (
              <BakeasyEmptyMsg message={'No Data Found'} />
            )} */}
          </Grid>

          {/* </> */}
        </Paper>
      </Grid>
    );
  }
  return recipeBuilderUI();
};
